'use strict';

/* eslint no-console: 0 */
define('lib/analytics/blocks/link.block',[
  'jquery',
  '../buildUrlFromHref',
  '../textTrimmer',
  '../config'
], function (
  $,
  buildUrlFromHref,
  textTrimmer,
  config
) {
  function __buildHref($el) {
    var href = $el.attr('href') || '#';
    if (href.indexOf('javascript') !== -1) {
      href = '#'; // if 'javascript:void', consider our href as '#'
    }
    return href;
  }

  function __linkText($el) {
    var txt = $el.data('linktext') || $el.text() || $el.attr('name') || '';
    return textTrimmer(txt);
  }

  // TODO: should we be using getContext here, in addittion to supporting the old?
  return function linkBlock($el) {
    var km = $el.data('km') || null;

    var block = {
      link_url: buildUrlFromHref(__buildHref($el)), // full URL (http://bat.com/newengland/foo/bar)
      link_href: __buildHref($el), // actual href attr of link (/newengland/foo/bar)
      link_text: __linkText($el), // text of link
      link_action: km ? 'km-link' : 'aa-link', // if it's a key-metric link, link_action needs to be updated
    };

    if (km) {
      block.metrics = km;
    }
    if (config.debug.blocks) {
      console.groupCollapsed('DL 1.5: Link Block');
      console.log(block);
      console.groupEnd();
    }

    return block;
  };

});

